import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '@/lib/api'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Never retry an auth/RBAC denial — the answer will not change.
        if (error instanceof ApiError && (error.isUnauthorized || error.isForbidden)) return false
        return failureCount < 2
      },
    },
    mutations: { retry: false },
  },
})
